// This file was auto-generated by generate_types in the remote crate.
// Do not edit manually.

// Electric row types
export type JsonValue = number | string | boolean | Array<JsonValue> | { [key in string]?: JsonValue } | null;

export type Project = { id: string, organization_id: string, name: string, color: string, created_at: string, updated_at: string, };

export type Notification = { id: string, organization_id: string, user_id: string, notification_type: NotificationType, payload: JsonValue, issue_id: string | null, comment_id: string | null, seen: boolean, dismissed_at: string | null, created_at: string, };

export type NotificationType = "IssueCommentAdded" | "IssueStatusChanged" | "IssueAssigneeChanged" | "IssueDeleted";

export type Workspace = { id: string, project_id: string, owner_user_id: string, issue_id: string | null, local_workspace_id: string | null, name: string | null, archived: boolean, files_changed: number | null, lines_added: number | null, lines_removed: number | null, created_at: string, updated_at: string, };

export type ProjectStatus = { id: string, project_id: string, name: string, color: string, sort_order: number, hidden: boolean, created_at: string, };

export type Tag = { id: string, project_id: string, name: string, color: string, };

export type Issue = { id: string, project_id: string, issue_number: number, simple_id: string, status_id: string, title: string, description: string | null, priority: IssuePriority | null, start_date: string | null, target_date: string | null, completed_at: string | null, sort_order: number, parent_issue_id: string | null, parent_issue_sort_order: number | null, extension_metadata: JsonValue, creator_user_id: string | null, created_at: string, updated_at: string, };

export type IssueAssignee = { id: string, issue_id: string, user_id: string, assigned_at: string, };

export type IssueFollower = { id: string, issue_id: string, user_id: string, };

export type IssueTag = { id: string, issue_id: string, tag_id: string, };

export type IssueRelationship = { id: string, issue_id: string, related_issue_id: string, relationship_type: IssueRelationshipType, created_at: string, };

export type IssueRelationshipType = "blocking" | "related" | "has_duplicate";

export type IssueComment = { id: string, issue_id: string, author_id: string | null, parent_id: string | null, message: string, created_at: string, updated_at: string, };

export type IssueCommentReaction = { id: string, comment_id: string, user_id: string, emoji: string, created_at: string, };

export type IssuePriority = "urgent" | "high" | "medium" | "low";

export type PullRequestStatus = "open" | "merged" | "closed";

export type PullRequest = { id: string, url: string, number: number, status: PullRequestStatus, merged_at: string | null, merge_commit_sha: string | null, target_branch_name: string, issue_id: string, workspace_id: string | null, created_at: string, updated_at: string, };

export type UserData = { user_id: string, first_name: string | null, last_name: string | null, username: string | null, };

export type User = { id: string, email: string, first_name: string | null, last_name: string | null, username: string | null, created_at: string, updated_at: string, };

export enum MemberRole { ADMIN = "ADMIN", MEMBER = "MEMBER" }

export type OrganizationMember = { organization_id: string, user_id: string, role: MemberRole, joined_at: string, last_seen_at: string | null, };

export type CreateProjectRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, organization_id: string, name: string, color: string, };

export type UpdateProjectRequest = { name: string | null, color: string | null, };

export type CreateNotificationRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, organization_id: string, seen: boolean, };

export type UpdateNotificationRequest = { seen: boolean | null, };

export type CreateTagRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, project_id: string, name: string, color: string, };

export type UpdateTagRequest = { name: string | null, color: string | null, };

export type CreateProjectStatusRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, project_id: string, name: string, color: string, sort_order: number, hidden: boolean, };

export type UpdateProjectStatusRequest = { name: string | null, color: string | null, sort_order: number | null, hidden: boolean | null, };

export type CreateIssueRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, project_id: string, status_id: string, title: string, description: string | null, priority: IssuePriority | null, start_date: string | null, target_date: string | null, completed_at: string | null, sort_order: number, parent_issue_id: string | null, parent_issue_sort_order: number | null, extension_metadata: JsonValue, };

export type UpdateIssueRequest = { status_id: string | null, title: string | null, description: string | null | null, priority: IssuePriority | null | null, start_date: string | null | null, target_date: string | null | null, completed_at: string | null | null, sort_order: number | null, parent_issue_id: string | null | null, parent_issue_sort_order: number | null | null, extension_metadata: JsonValue | null, };

export type CreateIssueAssigneeRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, issue_id: string, user_id: string, };

export type CreateIssueFollowerRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, issue_id: string, user_id: string, };

export type CreateIssueTagRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, issue_id: string, tag_id: string, };

export type CreateIssueRelationshipRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, issue_id: string, related_issue_id: string, relationship_type: IssueRelationshipType, };

export type CreateIssueCommentRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, issue_id: string, message: string, parent_id: string | null, };

export type UpdateIssueCommentRequest = { message: string | null, parent_id: string | null | null, };

export type CreateIssueCommentReactionRequest = { 
/**
 * Optional client-generated ID. If not provided, server generates one.
 * Using client-generated IDs enables stable optimistic updates.
 */
id?: string, comment_id: string, emoji: string, };

export type UpdateIssueCommentReactionRequest = { emoji: string | null, };

// Shape definition interface
export interface ShapeDefinition<T> {
  readonly table: string;
  readonly params: readonly string[];
  readonly url: string;
  readonly _type: T;  // Phantom field for type inference (not present at runtime)
}

// Helper to create type-safe shape definitions
function defineShape<T>(
  table: string,
  params: readonly string[],
  url: string
): ShapeDefinition<T> {
  return { table, params, url } as ShapeDefinition<T>;
}

// Individual shape definitions with embedded types
export const PROJECTS_SHAPE = defineShape<Project>(
  'projects',
  ['organization_id'] as const,
  '/v1/shape/projects'
);

export const NOTIFICATIONS_SHAPE = defineShape<Notification>(
  'notifications',
  ['organization_id', 'user_id'] as const,
  '/v1/shape/notifications'
);

export const ORGANIZATION_MEMBERS_SHAPE = defineShape<OrganizationMember>(
  'organization_member_metadata',
  ['organization_id'] as const,
  '/v1/shape/organization_members'
);

export const USERS_SHAPE = defineShape<User>(
  'users',
  ['organization_id'] as const,
  '/v1/shape/users'
);

export const PROJECT_TAGS_SHAPE = defineShape<Tag>(
  'tags',
  ['project_id'] as const,
  '/v1/shape/project/{project_id}/tags'
);

export const PROJECT_PROJECT_STATUSES_SHAPE = defineShape<ProjectStatus>(
  'project_statuses',
  ['project_id'] as const,
  '/v1/shape/project/{project_id}/project_statuses'
);

export const PROJECT_ISSUES_SHAPE = defineShape<Issue>(
  'issues',
  ['project_id'] as const,
  '/v1/shape/project/{project_id}/issues'
);

export const USER_WORKSPACES_SHAPE = defineShape<Workspace>(
  'workspaces',
  ['owner_user_id'] as const,
  '/v1/shape/user/workspaces'
);

export const PROJECT_WORKSPACES_SHAPE = defineShape<Workspace>(
  'workspaces',
  ['project_id'] as const,
  '/v1/shape/project/{project_id}/workspaces'
);

export const PROJECT_ISSUE_ASSIGNEES_SHAPE = defineShape<IssueAssignee>(
  'issue_assignees',
  ['project_id'] as const,
  '/v1/shape/project/{project_id}/issue_assignees'
);

export const PROJECT_ISSUE_FOLLOWERS_SHAPE = defineShape<IssueFollower>(
  'issue_followers',
  ['project_id'] as const,
  '/v1/shape/project/{project_id}/issue_followers'
);

export const PROJECT_ISSUE_TAGS_SHAPE = defineShape<IssueTag>(
  'issue_tags',
  ['project_id'] as const,
  '/v1/shape/project/{project_id}/issue_tags'
);

export const PROJECT_ISSUE_RELATIONSHIPS_SHAPE = defineShape<IssueRelationship>(
  'issue_relationships',
  ['project_id'] as const,
  '/v1/shape/project/{project_id}/issue_relationships'
);

export const PROJECT_PULL_REQUESTS_SHAPE = defineShape<PullRequest>(
  'pull_requests',
  ['project_id'] as const,
  '/v1/shape/project/{project_id}/pull_requests'
);

export const ISSUE_COMMENTS_SHAPE = defineShape<IssueComment>(
  'issue_comments',
  ['issue_id'] as const,
  '/v1/shape/issue/{issue_id}/comments'
);

export const ISSUE_REACTIONS_SHAPE = defineShape<IssueCommentReaction>(
  'issue_comment_reactions',
  ['issue_id'] as const,
  '/v1/shape/issue/{issue_id}/reactions'
);

// =============================================================================
// Mutation Definitions
// =============================================================================

// Mutation definition interface
export interface MutationDefinition<TRow, TCreate = unknown, TUpdate = unknown> {
  readonly name: string;
  readonly url: string;
  readonly _rowType: TRow;  // Phantom field for type inference (not present at runtime)
  readonly _createType: TCreate;  // Phantom field for type inference (not present at runtime)
  readonly _updateType: TUpdate;  // Phantom field for type inference (not present at runtime)
}

// Helper to create type-safe mutation definitions
function defineMutation<TRow, TCreate, TUpdate>(
  name: string,
  url: string
): MutationDefinition<TRow, TCreate, TUpdate> {
  return { name, url } as MutationDefinition<TRow, TCreate, TUpdate>;
}

// Individual mutation definitions
export const PROJECT_MUTATION = defineMutation<Project, CreateProjectRequest, UpdateProjectRequest>(
  'Project',
  '/v1/projects'
);

export const NOTIFICATION_MUTATION = defineMutation<Notification, unknown, UpdateNotificationRequest>(
  'Notification',
  '/v1/notifications'
);

export const TAG_MUTATION = defineMutation<Tag, CreateTagRequest, UpdateTagRequest>(
  'Tag',
  '/v1/tags'
);

export const PROJECT_STATUS_MUTATION = defineMutation<ProjectStatus, CreateProjectStatusRequest, UpdateProjectStatusRequest>(
  'ProjectStatus',
  '/v1/project_statuses'
);

export const ISSUE_MUTATION = defineMutation<Issue, CreateIssueRequest, UpdateIssueRequest>(
  'Issue',
  '/v1/issues'
);

export const ISSUE_ASSIGNEE_MUTATION = defineMutation<IssueAssignee, CreateIssueAssigneeRequest, unknown>(
  'IssueAssignee',
  '/v1/issue_assignees'
);

export const ISSUE_FOLLOWER_MUTATION = defineMutation<IssueFollower, CreateIssueFollowerRequest, unknown>(
  'IssueFollower',
  '/v1/issue_followers'
);

export const ISSUE_TAG_MUTATION = defineMutation<IssueTag, CreateIssueTagRequest, unknown>(
  'IssueTag',
  '/v1/issue_tags'
);

export const ISSUE_RELATIONSHIP_MUTATION = defineMutation<IssueRelationship, CreateIssueRelationshipRequest, unknown>(
  'IssueRelationship',
  '/v1/issue_relationships'
);

export const ISSUE_COMMENT_MUTATION = defineMutation<IssueComment, CreateIssueCommentRequest, UpdateIssueCommentRequest>(
  'IssueComment',
  '/v1/issue_comments'
);

export const ISSUE_COMMENT_REACTION_MUTATION = defineMutation<IssueCommentReaction, CreateIssueCommentReactionRequest, UpdateIssueCommentReactionRequest>(
  'IssueCommentReaction',
  '/v1/issue_comment_reactions'
);

// Type helpers to extract types from a mutation definition
export type MutationRowType<M extends MutationDefinition<unknown>> = M extends MutationDefinition<infer R> ? R : never;
export type MutationCreateType<M extends MutationDefinition<unknown, unknown>> = M extends MutationDefinition<unknown, infer C> ? C : never;
export type MutationUpdateType<M extends MutationDefinition<unknown, unknown, unknown>> = M extends MutationDefinition<unknown, unknown, infer U> ? U : never;
